import { FC } from "react";
import { Chip, Tooltip } from "@mui/material";
import InfoIcon from "@mui/icons-material/Info";
import __ from "src/utils/Translations";
import formatDayLabel from "src/utils/Company/Absences/formatDayLabel";
import { IEmployeeBalanceStatus } from "src/Pages/Company/Absences/AbsenceRecords/AbsenceRecords.models";

interface IBalanceStatusProps {
  label: string;
  status: IEmployeeBalanceStatus;
  helpText?: string;
}

const BalanceStatusChip: FC<IBalanceStatusProps> = ({
  label,
  status,
  helpText,
}) => {
  const { days, hours } = status;

  const iconElement = helpText ? (
    <Tooltip title={helpText} placement="top" arrow>
      <InfoIcon />
    </Tooltip>
  ) : undefined;

  return (
    <Chip
      label={
        <>
          {__(label)}
          {": "}
          <strong>
            {days} {__(formatDayLabel(days))} / {hours}h
          </strong>
        </>
      }
      {...(helpText && {
        // Need to use deleteIcon prop to display tooltip right-aligned
        deleteIcon: iconElement,
        onDelete: () => null, // Required for deleteIcon to show
      })}
      sx={{
        bgcolor: "grey.100",
      }}
    />
  );
};

export default BalanceStatusChip;
